exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cents[data-v-0d8b0013]{-webkit-transform:scale(.6);transform:scale(.6);-webkit-transform-origin:left top;transform-origin:left top;margin-left:.15em;margin-top:.06em}.cash-wrapper[data-v-0d8b0013]{display:-webkit-box;display:flex;line-height:1em!important}", ""]);
